var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B2BFCC;}\n\t.st1{fill:#00AEEF;stroke:#008DC9;stroke-width:3.8447;}\n\t.st2{fill:#FFFFFF;stroke:#B7BEC7;stroke-width:0.9612;}\n\t.st3{fill:#00AEEF;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{display:none;}\n\t.st6{display:inline;fill:#201600;stroke:#201600;stroke-width:0.1;stroke-linecap:square;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_76_",
    className: "st0",
    d: "M88,101.5c19.2-5.8,33.1-23.9,33.1-45.5c0-26.2-20.7-47.4-46.1-47.4S28.9,29.9,28.9,56 c0,21.5,14,39.7,33.1,45.5c6.2,2,10.2,7.3,11.7,13.8c0.1,0.6,0.7,1.1,1.3,1.1s1.1-0.4,1.3-1.1C77.8,108.8,81.8,103.5,88,101.5z"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_75_",
    className: "st1",
    cx: 75,
    cy: 135.6,
    r: 7.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_74_",
    className: "st2",
    d: "M88.9,102.2L88.9,102.2L88.9,102.2c-6.9,2.2-11.4,7.9-13,14.9c-0.1,0.4-0.5,0.7-0.9,0.7 s-0.8-0.3-0.9-0.7c-1.7-7-6.1-12.7-13-14.8h0l0,0c-20.6-6-35.6-25-35.6-47.4C25.5,27.4,47.7,5.3,75,5.3s49.5,22.1,49.5,49.4 C124.5,77.2,109.5,96.2,88.9,102.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_73_",
    className: "st3",
    d: "M75,93.3c21.2,0,38.4-17.2,38.4-38.4S96.2,16.4,75,16.4S36.6,33.6,36.6,54.8 S53.8,93.3,75,93.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_72_",
    className: "st4",
    d: "M56.7,41.4c0-5,4-9,9-9h9c5,0,9,4,9,9v12.4h0c3.6,0,6.5,2.9,6.5,6.5v8.5 c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3V52.3c-0.5,0.1-1,0.2-1.6,0.2c-3.1,0-5.6-2.5-5.6-5.6c0-2.2,1.3-4.1,3.1-5l-3-3 c-0.8-0.8-0.8-2.1,0-2.9c0.8-0.8,2.1-0.8,2.9,0l6.4,6.4c1.2,1.2,1.9,2.9,1.9,4.6v21.7c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4 v-8.5c0-1.4-1.1-2.5-2.5-2.5h0v10.5c0,5-4,9-9,9h-9c-5,0-9-4-9-9V41.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_71_",
    className: "st3",
    d: "M61.2,41.4c0-2.5,2-4.5,4.5-4.5h9c2.5,0,4.5,2,4.5,4.5v6.7c0,2.5-2,4.5-4.5,4.5h-9 c-2.5,0-4.5-2-4.5-4.5V41.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_66_",
    className: "st3",
    cx: 91.3,
    cy: 47,
    r: 1.6
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Linear",
    className: "st5"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_70_",
    className: "st6",
    x1: 145,
    y1: -1.8,
    x2: 145,
    y2: 166.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_69_",
    className: "st6",
    x1: 155.5,
    y1: 145,
    x2: -13.2,
    y2: 145
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_68_",
    className: "st6",
    x1: 5,
    y1: -12,
    x2: 5,
    y2: 156.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_67_",
    className: "st6",
    x1: 158.3,
    y1: 5,
    x2: -10.4,
    y2: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive);
export default __webpack_public_path__ + "static/media/43f5c4b2cfd748560e369c74979af3c234e4e5a331.svg";
export { ForwardRef as ReactComponent };